import {authorize, getRequest} from "utils/http";
import {AWS_API_URL} from "global/environment";

const url = `${AWS_API_URL}/get-living-information`;

export async function getLivingInfoAPI() {
  return getRequest(url, await authorize());
}
